import {
  call,
  cancel,
  delay,
  put,
  select,
  takeEvery,
  takeLatest
}                                 from 'redux-saga/effects';
import service                    from '../../services';
import {
  setAlarmScenarioList,
  setEvents,
  stopPollEvents
}                                 from "../alerts/actions";
import {
  ALERTS_POLL_EVENTS,
  ALERTS_STOP_POLL_EVENTS
}                                 from "../alerts/constants";
import { chooseServiceGenerator } from './utils';

function getPlaySound(playSoundState, alarmPriority, minPrio) {
  if (alarmPriority === 'none') return null;
  if (minPrio >= +alarmPriority) return minPrio >= +alarmPriority;
  return playSoundState
}

function* pollOcularisEventsSaga() {
  const {token} = yield select(state => state.API);

  while (true) {
    try {
      const {transactionId, events, playSound, initialLoad} = yield select(state => state.alerts);
      const {alarmPriority} = yield select(state => state.settings);
      const {data} = yield call(() => service.getAlarmsList(token, transactionId));
      const {transaction_id, Events} = data;

      if (Events.length || transactionId !== transaction_id) {
        const openedEvents = Events.filter(ev => ev.state === "Open")
          .sort((firtsEv, secEv) => firtsEv.prio - secEv.prio);
        const minPrio = openedEvents.length ? +openedEvents[0].prio : null;

        const closedEventsIds = Events
          .filter(ev => ev.state === "Closed")
          .reduce((hash, ev) => hash.add(ev.id), new Set());

        const currentEvents = events.filter(ev => !closedEventsIds.has(ev.id));
        const doPlaySound = getPlaySound(playSound, alarmPriority, minPrio);

        yield put(setEvents(initialLoad ? null : Events.length > 0 ? doPlaySound : null,
          typeof transaction_id === 'string' ? transaction_id : transactionId,
          currentEvents.concat(openedEvents)
        ));
      }
    } catch (e) {
      yield put(stopPollEvents());
    } finally {
      yield delay(5000)
    }
  }
}

function* pollCayugaEventsSaga() {
  const {token} = yield select(state => state.API);

  try {
    const {data, error} = yield call(() => service.getAlarmsList(token));
    if (error) {
      throw 'No scenario list';
    }
    const scenarioList = Array.isArray(data['a:AlarmScenarioInfo']) ? data['a:AlarmScenarioInfo'] : [data['a:AlarmScenarioInfo']];
    yield put(setAlarmScenarioList(scenarioList));
  } catch (e) {
    console.log(e);
  }

  while (true) {
    try {
      const {events, playSound, initialLoad, alarmScenarioList} = yield select(state => state.alerts);
      const {alarmPriority} = yield select(state => state.settings);

      const res = yield call(() => service.requestNewAlarm(token));

      if (res.error) {
        return 'Stop poll alarms events!';
      }
      const {data} = res;

      let newEvents = events;
      if (events.length > 0) {
        const alarmsIDs = alarmScenarioList.map(alarm => alarm['a:EntityID']);
        const eventsTimeList = events.map(event => parseInt(event.when));
        const startTime = Math.min.apply(null, eventsTimeList);
        const endTime = Math.max.apply(null, eventsTimeList);
        const triggeredAlarmsRes = yield call(() => service.searchTriggeredAlarms(token, startTime, endTime, alarmsIDs))
        if (!triggeredAlarmsRes.error) {
          const triggeredAlarms = Array.isArray(triggeredAlarmsRes.data['a:TriggeredAlarmInfo'])
            ? triggeredAlarmsRes.data['a:TriggeredAlarmInfo']
            : [triggeredAlarmsRes.data['a:TriggeredAlarmInfo']];
          newEvents = newEvents.filter(event => triggeredAlarms.some(alarm => alarm['a:EventID'] === event.id));
        }
      }

      if (data['a:AlarmScenarioID'] !== '-1') {
        const involvedCameras = Array.isArray(data['a:InvolvedCameras']['a:Camera'])
          ? data['a:InvolvedCameras']['a:Camera']
          : [data['a:InvolvedCameras']['a:Camera']];
        const whereData = involvedCameras.map(cam => typeof (cam['a:Name']) === 'string' ? cam['a:Name'] : '').join(', ');
        const alarmScenario = alarmScenarioList.find(scenario => scenario['a:EntityID'] === data['a:AlarmScenarioID'])
        const prio = 10 - (parseInt(alarmScenario['a:Priority']) - 10) / 20;
        const newData = {
          prio: prio,
          what: data['a:Description'],
          when: data['a:Timestamp'],
          id: data['a:ID'],
          where_id: data['a:AlarmScenarioID'],
          where: whereData,
          cameras: involvedCameras
        };

        const doPlaySound = getPlaySound(playSound, alarmPriority, prio);

        yield put(setEvents(initialLoad ? null : events.length > 0 ? doPlaySound : false,
          null,
          newEvents.concat(newData)
        ));
      } else {
        if (events.length !== newEvents.length) {
          yield put(setEvents(initialLoad ? null : false,
            null,
            newEvents
          ));
        }
      }
    } catch (e) {
      console.log(e);
      yield put(stopPollEvents());
    } finally {
      yield delay(5000)
    }
  }
}

function* cancelAndReinit(oldTask) {
  yield cancel(oldTask);
  const newTask = yield takeEvery(ALERTS_POLL_EVENTS, chooseServiceGenerator,
    {fn: pollOcularisEventsSaga, args: []},
    {fn: pollCayugaEventsSaga, args: []}
  );

  yield takeLatest(ALERTS_STOP_POLL_EVENTS, cancelAndReinit, newTask);
}

export default function* startPollEventsSaga() {
  const task = yield takeEvery(ALERTS_POLL_EVENTS, chooseServiceGenerator,
    {fn: pollOcularisEventsSaga, args: []},
    {fn: pollCayugaEventsSaga, args: []}
  );

  yield takeLatest(ALERTS_STOP_POLL_EVENTS, cancelAndReinit, task);
}